<div class="m-4 bg-white">
  <div class="row">
    <div class="col-md-6">
      <form [formGroup]="settingsForm">
        <div class="form-group">
          <label class="form-label text-black"
            >Auto recharge when balance goes below ($) <sup class="text-danger">*</sup></label
          >
          <input
            type="number"
            class="form-control"
            formControlName="recharge_threshold"
            matTooltip="Your balance will be recharged when you hit this amount"
            matTooltipPosition="above"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="
              settingsForm.get('recharge_threshold').hasError('required') &&
              settingsForm.get('recharge_threshold').touched
            "
          >
            Value is required
          </div>
          <div class="invalid-feedback d-block" *ngIf="settingsForm.get('recharge_threshold').hasError('positive')">
            Value should be greater than <strong>0</strong>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label text-black">Bring balance back up to ($) <sup class="text-danger">*</sup></label>
          <input
            type="number"
            class="form-control"
            formControlName="recharge_balance"
            matTooltip="This amount will be your actual credit/balance after recharge"
            matTooltipPosition="above"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="
              settingsForm.get('recharge_balance').hasError('required') && settingsForm.get('recharge_balance').touched
            "
          >
            Value is required
          </div>
          <div class="invalid-feedback d-block" *ngIf="settingsForm.get('recharge_balance').hasError('positive')">
            Value should be greater than <strong>0</strong>
          </div>
        </div>
        <div class="alert alert-warning">
          Note: TokeetAI credit will be deducted equally for every generated message even if it's not sent (i.e draft)
        </div>
        <div class="d-flex">
          <button class="btn btn-success ml-auto text-uppercase" (click)="onSave(settingsForm)">
            <i class="fa fa-save"></i> Save
          </button>
        </div>
      </form>
    </div>

    <div class="col-md-6 border-left">
      <form [formGroup]="rechargeForm">
        <div class="form-group">
          <label class="form-label text-black">Instant Recharge ($) <sup class="text-danger">*</sup></label>
          <input
            type="number"
            class="form-control"
            formControlName="recharge_amount"
            matTooltip="Your balance will be increased immediately"
            matTooltipPosition="above"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="
              rechargeForm.get('recharge_amount').hasError('required') && rechargeForm.get('recharge_amount').touched
            "
          >
            Value is required
          </div>
          <div class="invalid-feedback d-block" *ngIf="rechargeForm.get('recharge_amount').hasError('positive')">
            Value should be greater than <strong>0</strong>
          </div>
          <div class="invalid-feedback d-block" *ngIf="rechargeForm.get('recharge_amount').hasError('min')">
            Value should be greater than <strong>5</strong>
          </div>
        </div>
        <div class="d-flex">
          <button
            [disabled]="isRecharging"
            class="btn btn-success ml-auto text-uppercase"
            (click)="onCharge(rechargeForm)"
          >
            <i class="fa fa-save"></i> Recharge
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
